<template>
  <section></section>
</template>

<script>
import SendMessage from '../WeChat/SendMessage.vue'
export default {
  components: { SendMessage },

}
</script>

<style>

</style>